import type { LoginParams, LoginResult } from '@/interfaces/user';
import Requests from './request';
import $i18n from '../i18n';
import { history } from 'ice';
import { queryPathName } from '../utils/url-parse';

export async function login(data: LoginParams): Promise<LoginResult> {
  const { username, password, validateCode, validateCodeKey, verifyCode } = data;

  const locale = $i18n.siteLocale || 'en-US';

  return Requests.post(
    '/uc/login',
    {
      loginType: 'pwd',
      source: 'pc',
      loginIdentifier: username,
      validateCode, 
      validateCodeKey,
      verifyCode,
      credential: {
        pwd: password,
      },
    },
    {
      headers: {
        'uc-loginChannel': 'pc',
        'uc-accountType': 'M',
        'x-locale': locale,
      },
    },
  )
    .then((res) => {
      if (!res || res?.validateCodeImage) {
        return {
          success: false,
          userType: 'guest',
          validateCodeImage: res?.validateCodeImage,
          validateCodeKey: res?.validateCodeKey,
        };
      }
      return {
        success: true,
        userType: 'admin',
      };
    })
    .catch((err) => {
      return {
        successs: false,
        userType: 'guest',
        validateCodeImage: err?.data?.validateCodeImage,
        validateCodeKey: err?.data?.validateCodeKey,
      };
    });
}

export async function fetchUserInfo() {
  const currentPath = queryPathName();
  const toRegisterIfNotLogin = ['/settlein', '/joinspace'].includes(currentPath);
  return Requests.get('/rest/intercnn/user/info', {}, { toRegisterIfNotLogin }).then((data) => {
    let result = {};
    if (data) {
      result = {
        accountType: data.accountType,
        userNick: data.userNick,
        accountId: data.accountId,
        userAvatar: data.userAvatar,
        tenantRole: data.tenantRole,
        defaultSpace: data.defaultSpace,
        isAliyunPaymentUser: data.isAliyunPaymentUser,
        isDuibaUser: data.isDuibaUser,
        status: data?.status,
        accountSrc: data?.accountSrc,
      };
    }
    window.loggerConfig = Object.assign({}, window.loggerConfig || {}, {
      userId: data?.userId,
      userNick: data?.userNick,
      accountId: data?.accountId,
      account: data?.account,
    });
    window.AES?.setConfig({
      uid: data?.accountId,
      username: data?.account,
    });
    return result;
  });
}

export async function logout() {
  return Requests.get('/uc/logout');
}

export async function getSendCode(data: any) {
  return Requests.post('/uc/update/validation', data, {
    headers: {
      'uc-loginChannel': 'pc',
      'uc-accountType': 'M',
    },
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
}

export async function sendLoginCode(data: any) {
  const locale = $i18n.siteLocale || 'en-US';
  return Requests.post('/rest/intercnn/user/global/sendLoginCode', data, {
    headers: {
      'uc-loginChannel': 'pc',
      'uc-accountType': 'M',
      'x-locale': locale
    },
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
}

export async function setVerification(data: any) {
  return Requests.post('/uc/risk/second/verification', data, {
    headers: {
      'uc-loginChannel': 'pc',
      'uc-accountType': 'M',
    },
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
}
